import { AuthForm } from "@/components/AuthForm";
import { InstallButton } from "@/components/InstallButton";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { useAuth } from "@/hooks/auth/useAuth";
import { useCanInstallPWA } from "@/hooks/useCanInstallPWA";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isStandalonePWA } from "ua-parser-js/helpers";

const Landing = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const { canInstall } = useCanInstallPWA();

  // Redirect authenticated users to characters page
  useEffect(() => {
    if (user && !loading) {
      navigate("/home");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-linear-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center">
        <div className="flex items-center justify-center">
          <img
            src="/text-logo.svg"
            alt="Logo"
            className="w-2/3 animate-pulse"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-linear-to-br from-blue-50 via-purple-50 to-pink-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-20 pb-8">
        {/* Background Decorations */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none -z-10">
          <div
            className="absolute inset-0 bg-linear-to-r from-indigo-100 to-blue-100 opacity-30 rounded-full blur-3xl"
            style={{
              transform: "scale(1.2)",
            }}
          />
          <div
            className="absolute inset-0 bg-linear-to-b from-blue-50 via-transparent to-transparent opacity-20"
            style={{
              transform: "translateY(-20%)",
            }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-8 leading-tight">
              <p>Découvrez</p>
              <img
                src="/text-logo.svg"
                alt="Sylvain.ai"
                className="inline-block align-middle h-12 sm:h-16 lg:h-20"
                style={{ verticalAlign: "middle" }}
              />
            </h1>
            <p className="text-xl sm:text-2xl text-gray-600 mb-12 leading-relaxed max-w-3xl mx-auto">
              L'intelligence artificielle qui vous fait découvrir des
              personnalités fascinantes à travers des conversations authentiques
              et enrichissantes.
            </p>

            <div className="space-y-6">
              <InstallButton />
              <Dialog defaultOpen={isStandalonePWA()}>
                <DialogTrigger asChild>
                  <Button
                    size="lg"
                    className="w-full h-12"
                    variant={canInstall ? "outline" : "default"}
                  >
                    {canInstall ? "Rester sur navigateur" : "Commencer l'aventure"}
                  </Button>
                </DialogTrigger>
                <DialogContent>
                  <AuthForm />
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
